export const ANSICHTEN_STANDARD = 'beide';
/** Ansichten einer Karte mit dem Standard fuer aeltere Dokumente. */
export function erlaubteAnsichten(map) {
    return map.ansichten ?? ANSICHTEN_STANDARD;
}
//# sourceMappingURL=map.js.map